import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const fjJobsTypesApi = createApi({
  reducerPath: 'fjJobsTypesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getFjJobsTypes: builder.query({
      query: () => ({
        url: urls.friJobsTypes,
      }),
    }),
  }),
});

export const { useGetFjJobsTypesQuery } = fjJobsTypesApi;
